import { PricingSchemeWrite } from 'src/common/external/bambi-api/bambiApi';

export type PricingSchemeWriteKeysForStepOne =
  | 'name'
  | 'description'
  | 'start_date'
  | 'end_date'
  | 'space_types'
  | 'service_types'
  | 'payer_ids';

export type SchemeMetaFormValues = Pick<
  PricingSchemeWrite,
  PricingSchemeWriteKeysForStepOne
> & {
  mileage_range_lower_miles: number | null;
  mileage_range_upper_miles: number | null;
};

export function milesToHundredths(miles: number | null): number | null {
  return miles && !isNaN(miles) ? Math.round(miles * 100) : null;
}

export const defaultValues: SchemeMetaFormValues = {
  name: '',
  payer_ids: [],
  space_types: [],
  service_types: [],
  start_date: '',
  end_date: '',
  description: '',
  mileage_range_lower_miles: null,
  mileage_range_upper_miles: null,
};
